import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import { AddDiameterCommand } from './AddDiameter.command';
import type { IMeasurementViewModel } from '@/engine/app/interfaces';
import { RemoveDiameterCommand } from './RemoveDiameter.command';
import type { ViewsService } from '@/engine/app/Views.service';
import type * as DT from '@/engine/PlanningAlgorithm/DataTypes';

export enum DiametersCommandType {
  AddPreset = 'AddDiameter',
  RemovePreset = 'RemoveDiameter'
}

@injectable()
export class DiametersCommandsFactory {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _viewsService: ViewsService;

  public constructor(
    @inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm,
    @inject(TYPES.ViewsService) viewsService: ViewsService
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._viewsService = viewsService;
  }

  public createCommand(
    view: ViewEntity,
    descriptor: string,
    model: DT.AreaMeasurement,
    viewModel: IMeasurementViewModel,
    commandType: DiametersCommandType
  ): ICommand {
    switch (commandType) {
      case DiametersCommandType.AddPreset:
        return new AddDiameterCommand(view, descriptor, model, viewModel, this._planningAlgorithm, this._viewsService);
      case DiametersCommandType.RemovePreset:
        return new RemoveDiameterCommand(
          view,
          descriptor,
          model,
          viewModel,
          this._planningAlgorithm,
          this._viewsService
        );
      default:
        throw new Error('Invalid command type');
    }
  }
}
